// @generated by protobuf-ts 2.11.1 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/event/activity/v2/extension/loyalty/viewed_tier_level_updated.proto" (package "bianka.event.activity.v2.extension.loyalty", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Organization } from "../../../../../core/enrichment/organization";
import { TierLevel } from "./common";
import { EventSource } from "./common";
import { Component } from "./common";
import { User } from "../../../../../core/enrichment/user";
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.loyalty.ViewedTierLevelUpdated
 */
export interface ViewedTierLevelUpdated {
    /**
     * The user who clicked the link
     *
     * @generated from protobuf field: bianka.core.enrichment.User user = 1
     */
    user?: User;
    /**
     * The clicked component
     *
     * @generated from protobuf field: bianka.event.activity.v2.extension.loyalty.Component component = 2
     */
    component?: Component;
    /**
     * @generated from protobuf field: optional bianka.event.activity.v2.extension.loyalty.EventSource event_source = 3
     */
    eventSource?: EventSource;
    /**
     * The loyalty tier of member
     *
     * @generated from protobuf field: bianka.event.activity.v2.extension.loyalty.TierLevel tier_level = 4
     */
    tierLevel: TierLevel;
    /**
     * @generated from protobuf field: bianka.core.enrichment.Organization organization = 5
     */
    organization?: Organization;
}
// @generated message type with reflection information, may provide speed optimized methods
class ViewedTierLevelUpdated$Type extends MessageType<ViewedTierLevelUpdated> {
    constructor() {
        super("bianka.event.activity.v2.extension.loyalty.ViewedTierLevelUpdated", [
            { no: 1, name: "user", kind: "message", T: () => User },
            { no: 2, name: "component", kind: "message", T: () => Component },
            { no: 3, name: "event_source", kind: "enum", opt: true, T: () => ["bianka.event.activity.v2.extension.loyalty.EventSource", EventSource, "EVENT_SOURCE_"] },
            { no: 4, name: "tier_level", kind: "enum", T: () => ["bianka.event.activity.v2.extension.loyalty.TierLevel", TierLevel, "TIER_LEVEL_"] },
            { no: 5, name: "organization", kind: "message", T: () => Organization }
        ], { "bianka.core.extension.enrichment": { groupName: "event_ng" } });
    }
    create(value?: PartialMessage<ViewedTierLevelUpdated>): ViewedTierLevelUpdated {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tierLevel = 0;
        if (value !== undefined)
            reflectionMergePartial<ViewedTierLevelUpdated>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ViewedTierLevelUpdated): ViewedTierLevelUpdated {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bianka.core.enrichment.User user */ 1:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* bianka.event.activity.v2.extension.loyalty.Component component */ 2:
                    message.component = Component.internalBinaryRead(reader, reader.uint32(), options, message.component);
                    break;
                case /* optional bianka.event.activity.v2.extension.loyalty.EventSource event_source */ 3:
                    message.eventSource = reader.int32();
                    break;
                case /* bianka.event.activity.v2.extension.loyalty.TierLevel tier_level */ 4:
                    message.tierLevel = reader.int32();
                    break;
                case /* bianka.core.enrichment.Organization organization */ 5:
                    message.organization = Organization.internalBinaryRead(reader, reader.uint32(), options, message.organization);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ViewedTierLevelUpdated, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bianka.core.enrichment.User user = 1; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bianka.event.activity.v2.extension.loyalty.Component component = 2; */
        if (message.component)
            Component.internalBinaryWrite(message.component, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* optional bianka.event.activity.v2.extension.loyalty.EventSource event_source = 3; */
        if (message.eventSource !== undefined)
            writer.tag(3, WireType.Varint).int32(message.eventSource);
        /* bianka.event.activity.v2.extension.loyalty.TierLevel tier_level = 4; */
        if (message.tierLevel !== 0)
            writer.tag(4, WireType.Varint).int32(message.tierLevel);
        /* bianka.core.enrichment.Organization organization = 5; */
        if (message.organization)
            Organization.internalBinaryWrite(message.organization, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.loyalty.ViewedTierLevelUpdated
 */
export const ViewedTierLevelUpdated = new ViewedTierLevelUpdated$Type();
